import { amplifyClient, axios, getEndpointV2 } from 'api';
import { call, select } from 'redux-saga/effects';
import { userFetch } from 'store/features/userFetch';
import { ApiError, UserData, UserRfcConfigType } from 'types';

export interface UpdateAddReturn {
  error: ApiError | null;
}

export function* uploadRfcFile({
  file,
  code,
  type,
}: {
  file: File;
  code: string;
  type: UserRfcConfigType;
}): Generator<unknown, string> {
  const { companyId } = (yield select(userFetch.selectors.getData)) as UserData;

  if (typeof file === 'string') {
    throw 'Wrong file'; // should not arrive here
  }

  const ext = file.name.split('.')?.[1];
  const configType = type === 'csd' ? 'CSD' : 'FIEL';

  const { key, url } = (yield call(amplifyClient, {
    method: 'get',
    url: getEndpointV2({
      path: '/auth/company/:companyId/rfc/:code/signedUrl',
      urlParams: { companyId, code },
      params: { ext, configType },
    }),
  })) as { key: string; url: string };

  yield call(axios, {
    method: 'put',
    url,
    data: file,
  });

  return key;
}
